import { getHost } from '../../utils/browser';
import {XC_URL} from '../../config';


import {
	USER_UPDATE_SUCCESS,
	ACCOUNT_EMAIL_UPDATE,
	ACCOUNT_EMAIL_UPDATE_SUCCESS,
	ACCOUNT_EMAIL_UPDATE_FAIL,
	ACCOUNT_CHECK_CREDENTIALS,
	ACCOUNT_CHECK_CREDENTIALS_SUCCESS,
	ACCOUNT_CHECK_CREDENTIALS_FAIL,
	ACCOUNT_NAME_UPDATE,
	ACCOUNT_NAME_UPDATE_SUCCESS,
	ACCOUNT_NAME_UPDATE_FAIL,
	ACCOUNT_PASSWORD_UPDATE,
	ACCOUNT_PASSWORD_UPDATE_SUCCESS,
	ACCOUNT_PASSWORD_UPDATE_FAIL,
	ACCOUNT_PASSWORD_RESET,
	ACCOUNT_PASSWORD_RESET_SUCCESS,
	ACCOUNT_PASSWORD_RESET_FAIL,
	SOCKET_SUBSCRIBE,
	VERIFY_ACCOUNT_RESEND_FETCH,
	VERIFY_ACCOUNT_RESEND_FETCH_SUCCESS,
	VERIFY_ACCOUNT_RESEND_FETCH_FAIL
} from './actions';
import { showQuickMessage } from 'redux/modules/quickMessages';
import { extractPropsforSuperagentHttpError } from '../../errors/errorhelper';
import ERRORS from '../../errors/errorids';
import AppError from '../../errors/apperror';
import HttpError from '../../errors/httperror';
import { AUTHENTICATION } from '../../config';
import _ from 'lodash';

const initialState = {
	areCredentialsValid: null,
	checkCredentialsErrorid: null,
	accountEmailUpdateSuccess: null,
	accountEmailUpdateErrorId: null,
	accountNameUpdateSuccess: null,
	accountNameUpdateErrorId: null,
	accountPasswordUpdateSuccess: null,
	accountPasswordUpdateErrorId: null,
	accountPasswordResetSuccess: null,
	accountPasswordResetErrorId: null	
};

export default (state = initialState, action) => {
	switch (action.type) {
		/* credentials check */
		case ACCOUNT_CHECK_CREDENTIALS:
			return {
				...state,
				areCredentialsValid: null,
				checkCredentialsErrorid: null
			};

		case ACCOUNT_CHECK_CREDENTIALS_SUCCESS: {

			return {
				...state,
				areCredentialsValid: true,
				checkCredentialsErrorid: null
			};
		}

		case ACCOUNT_CHECK_CREDENTIALS_FAIL: {
			return {
				...state,
				areCredentialsValid: false,
				checkCredentialsErrorid: _.get(action, 'error.errorId')
			};
		}

		/* email update */
		case ACCOUNT_EMAIL_UPDATE:
			return {
				...state,
				accountEmailUpdateSuccess: null,
				accountEmailUpdateErrorId: null
			};

		case ACCOUNT_EMAIL_UPDATE_SUCCESS:
			return {
				...state,
				accountEmailUpdateSuccess: true,
				accountEmailUpdateErrorId: null
			};

		case ACCOUNT_EMAIL_UPDATE_FAIL:
			return {
				...state,
				accountEmailUpdateSuccess: false,
				accountEmailUpdateErrorId: _.get(action, 'error.errorId')
			};

		/* name update */
		case ACCOUNT_NAME_UPDATE:
			return {
				...state,
				accountNameUpdateSuccess: null,
				accountNameUpdateErrorId: null
			};
	
		case ACCOUNT_NAME_UPDATE_SUCCESS:
			return {
				...state,
				accountNameUpdateSuccess: true,
				accountNameUpdateErrorId: null
			};
	
		case ACCOUNT_NAME_UPDATE_FAIL:
			return {
				...state,
				accountNameUpdateSuccess: false,
				accountNameUpdateErrorId: _.get(action, 'error.errorId')
			};
		
		/* password update */
		case ACCOUNT_PASSWORD_UPDATE:
			return {
				...state,
				accountPasswordUpdateSuccess: null,
				accountPasswordUpdateErrorId: null
			};
	
		case ACCOUNT_PASSWORD_UPDATE_SUCCESS:
			return {
				...state,
				accountPasswordUpdateSuccess: true,
				accountPasswordUpdateErrorId: null
			};
	
		case ACCOUNT_PASSWORD_UPDATE_FAIL:
			return {
				...state,
				accountPasswordUpdateSuccess: false,
				accountPasswordUpdateErrorId: _.get(action, 'error.errorId')
			};			

		/* password reset */
		case ACCOUNT_PASSWORD_RESET:
			return {
				...state,
				accountPasswordResetSuccess: null,
				accountPasswordResetErrorId: null
			};
	
		case ACCOUNT_PASSWORD_RESET_SUCCESS:
			return {
				...state,
				accountPasswordResetSuccess: true,
				accountPasswordResetErrorId: null
			};
	
		case ACCOUNT_PASSWORD_RESET_FAIL:
			return {
				...state,
				accountPasswordResetSuccess: false,
				accountPasswordResetErrorId: _.get(action, 'error.errorId')
			};

		default:
			return state;

	}
};

export const updateEmail = (currentEmail, currentPassword, newEmail) => {
	return (dispatch) => {
		return dispatch({
			types: [ACCOUNT_EMAIL_UPDATE, ACCOUNT_EMAIL_UPDATE_SUCCESS, ACCOUNT_EMAIL_UPDATE_FAIL],
			promise: client => client.patch(AUTHENTICATION.SIGN_UP_URL, {
				data: {
					'host': getHost(),
					'current-email': currentEmail,
					'current-password': currentPassword,
					'new-email': newEmail
				}
			}).catch((error) => {
				const httpErrorProps = extractPropsforSuperagentHttpError(error);
				const nError = new AppError({
					message: 'user.updateEmail() failed',
					errorId: ERRORS.UNKNOWN,
					originalError: new HttpError(httpErrorProps),
					visualisers: { feature: 'REDUX_USER' }
				});

				throw nError;
			})
		});
	};
};

export const updateName = (currentEmail, currentPassword, firstName, lastName) => {
	return (dispatch) => {
		return dispatch({
			types: [ACCOUNT_NAME_UPDATE, ACCOUNT_NAME_UPDATE_SUCCESS, ACCOUNT_NAME_UPDATE_FAIL],
			promise: client => client.patch(AUTHENTICATION.SIGN_UP_URL, {
				data: {
					'host': getHost(),
					'current-email': currentEmail,
					'current-password': currentPassword,
					'firstName': firstName,
					'lastName': lastName
				}
			}).then(() => {
				showQuickMessage('Name was successfully updated').call(this, dispatch);
			}).catch((error) => {
				const httpErrorProps = extractPropsforSuperagentHttpError(error);
				const nError = new AppError({
					message: 'user.updateName() failed',
					errorId: ERRORS.UNKNOWN,
					originalError: new HttpError(httpErrorProps),
					visualisers: { feature: 'REDUX_USER' }
				});

				throw nError;
			})
		});
	};
};

export const updatePassword = (currentEmail, currentPassword, newPassword, confirmNewPassword) => {
	return (dispatch) => {
		return dispatch({
			types: [ACCOUNT_PASSWORD_UPDATE, ACCOUNT_PASSWORD_UPDATE_SUCCESS, ACCOUNT_PASSWORD_UPDATE_FAIL],
			promise: client => client.patch(AUTHENTICATION.SIGN_UP_URL, {
				data: {
					'host': getHost(),
					'current-email': currentEmail,
					'current-password': currentPassword,
					'new-password': newPassword,
					'confirm-password': confirmNewPassword
				}
			}).then(() => {
				showQuickMessage('Password was successfully updated').call(this, dispatch);
			}).catch((error) => {
				const httpErrorProps = extractPropsforSuperagentHttpError(error);
				const nError = new AppError({
					message: 'user.updatePassword() failed',
					errorId: ERRORS.UNKNOWN,
					originalError: new HttpError(httpErrorProps),
					visualisers: { feature: 'REDUX_USER' }
				});

				throw nError;
			})
		});
	};
};

export const resetPassword = (qs) => {
	return (dispatch) => {
		return dispatch({
			types: [ACCOUNT_PASSWORD_RESET, ACCOUNT_PASSWORD_RESET_SUCCESS, ACCOUNT_PASSWORD_RESET_FAIL],
			promise: client => client.get(AUTHENTICATION.RESET_PASSWORD_URL + qs, {
				data: {},
				headers: {
					'skip-recaptcha': true
				}
			}).catch((error) => {
				const httpErrorProps = extractPropsforSuperagentHttpError(error);
				const nError = new AppError({
					message: 'user.resetPassword() failed',
					errorId: ERRORS.UNKNOWN,
					originalError: new HttpError(httpErrorProps),
					visualisers: { feature: 'REDUX_USER' }
				});

				throw nError;
			})
		});
	};
};

export const checkCredentials = (currentEmail, currentPassword) => {
	return (dispatch) => {
		return dispatch({
			types: [ACCOUNT_CHECK_CREDENTIALS, ACCOUNT_CHECK_CREDENTIALS_SUCCESS, ACCOUNT_CHECK_CREDENTIALS_FAIL],
			promise: client => client.post(AUTHENTICATION.SIGN_IN_URL, {
				data: {
					email: currentEmail,
					password: currentPassword
				},
				headers: {
					'skip-recaptcha': true
				}
			}).catch((error) => {
				const httpErrorProps = extractPropsforSuperagentHttpError(error);
				const nError = new AppError({
					message: 'user.checkCredentials() failed',
					errorId: ERRORS.UNKNOWN,
					originalError: new HttpError(httpErrorProps),
					visualisers: { feature: 'REDUX_USER' }
				});

				throw nError;
			})
		});
	};
};

// SOCKET EVENTS
export const connectUserSocketEventProviderChange = () => {
	return (dispatch, getState) => {
		dispatch({
			type: SOCKET_SUBSCRIBE,
			// Event happens when password, name, email are updated
			event: 'user:change:providers',
			callback: payload => {
				dispatch({
					type: USER_UPDATE_SUCCESS,
					payload: {
						firstName: payload.firstName,
						lastName: payload.lastName,
						name: payload.name,
						hasPassword: payload.hasPassword
					}
				});
			}
		});
	};
};

export const connectUserSocketEventLogout = () => {
	return (dispatch, getState) => {
		dispatch({
			type: SOCKET_SUBSCRIBE,
			event: 'user:logout',
			callback: () => {
				window.location.href = XC_URL;
			}
		});
	};
};

export const sendVerifyAccountEmail = (email) => {
	return {
		types: [VERIFY_ACCOUNT_RESEND_FETCH, VERIFY_ACCOUNT_RESEND_FETCH_SUCCESS, VERIFY_ACCOUNT_RESEND_FETCH_FAIL],
		promise: client => client.post('/xara-basic/confirmation/resend', {
			data: {
				email,
				host: XC_URL
			},
		}).catch((error) => {
			const httpErrorProps = extractPropsforSuperagentHttpError(error);
			const nError = new AppError({
				message: 'companies.sendVerifyAccountEmail() failed',
				errorId: ERRORS.UNKNOWN,
				originalError: new HttpError(httpErrorProps),
				visualisers: { feature: 'REDUX_COMPANIES' }
			});

			throw nError;
		})
	};
};


// WEBPACK FOOTER //
// ./src/redux/modules/account.js